import i18n from '@/utils/i18n';
import React from 'react';
import { AlertCardSkeleton } from '@/experiences/sales-portal/domain/insights/components/alert-card/alert-card-skeleton';
import { createStyles } from '@/contexts/theme-context';
import { Separator } from '@usepepper/sprout-kit-ui';
import { View } from 'react-native';

const GROUP_COUNT = 5;

export const AlertFeedSkeleton: React.FC = () => {
  const [styles] = useStyles();

  return (
    <View
      accessibilityLabel={i18n.t('loading')}
      accessibilityState={{ busy: true }}
      style={styles.container}
    >
      {Array.from({ length: GROUP_COUNT }, (_, groupIndex) => (
        <View key={groupIndex}>
          {groupIndex > 0 ? <Separator /> : null}
          <AlertCardSkeleton />
        </View>
      ))}
    </View>
  );
};

const useStyles = createStyles((theme) => ({
  container: {
    backgroundColor: theme.sk.color.bg.primary.default,
    borderColor: theme.sk.color.border.primary,
    borderRadius: theme.sk.radii.radiusLarge,
    borderWidth: 1,
    overflow: 'hidden',
  },
}));
